import { Injectable, Inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SubscribeService {
  constructor(@Inject('ServiceByType') private ServiceByType: any) {}

  subscribe(item: { type: string; id: number }): Promise<any> {
    const service = this.ServiceByType.get(item.type);
    if (typeof service.subscribe === 'function') {
      return service.subscribe(item.id);
    }
  }

  unsubscribe(item: { type: string; id: number }): Promise<any> {
    const service = this.ServiceByType.get(item.type);
    if (typeof service.unsubscribe === 'function') {
      return service.unsubscribe(item.id);
    }
  }
}
